<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch,computed } from 'vue'
import CustomList from "../../compositions/CustomList.vue";
import ModalDialog from "../../compositions/ModalDialog.vue";
import TextBox from "../../compositions/TextBox.vue";
import SelectBox from "../../compositions/SelectBox.vue";
import CheckBox from "../../compositions/CheckBox.vue";
import config from "../../config.js";
import { errorAlert,confirmAlert } from "../../plugins/alert";
import { getFieldValue, deepCopy } from '../../plugins/utility';
import qs from 'qs';
import axios from '../../plugins/axios.ts';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    identityId:{
      type:Number,
      required:true,
    },
    nonMedicineId:{
      type:Number,
      required:true,
    },
    submit:{
      type:Function,
    },
    cancel:{
      type:Function,
    },
})

const { nonMedicineId,identityId } = toRefs(props);
const isLoading = ref(false);
const isReadOnly = ref(false);
const nonMeidicine = reactive([]);
const setDefaultNonMeidicine = () => {
  nonMeidicine.splice(0);
  nonMeidicine.push({
    id:props.nonMedicineId,
    medicine_type:config.NON_MEDICINE_TYPES['医療材料・医療機器'],
  })
}

const getMedicine = async () => {
  if (getNonMedicineValue('id') > 0) {
    return;
  }
  isReadOnly.value = false;
  if (!getNonMedicineValue('sales_packaging_unit_code')) {
    return;
  }
  isLoading.value = true;
  try {
    let params = {sales_packaging_unit_code:getNonMedicineValue('sales_packaging_unit_code')};
    const paramsSerializer = (params) => qs.stringify(params);
    const response = await axios.get(props.apis.medicine_detail,{params:params,paramsSerializer});
    if (response.data.data != null) {
      if (response.data.data.medicine_type == 0) {
        errorAlert('メディコード医薬品が既に登録済みです。通常の発注作業を行ってください。');
        return;
      }
      setNonMedicineValue(response.data.data.non_medicine_id,{field_key:'id'});
      setNonMedicineValue(response.data.data.receipt_code1,{field_key:'receipt_code1'});
      setNonMedicineValue(response.data.data.package_unit_number,{field_key:'package_unit_number'});
      setNonMedicineValue(response.data.data.package_unit,{field_key:'package_unit'});
      setNonMedicineValue(response.data.data.package_quantity_number,{field_key:'package_quantity_number'});
      setNonMedicineValue(response.data.data.package_quantity,{field_key:'package_quantity'});
      isReadOnly.value = true;
    }
  } finally {
    isLoading.value = false;
  }
}

const getNonMedicine = async () => {
  nonMeidicine.splice(0);
  isReadOnly.value = false;
  isLoading.value = true;
  try {
    let params = {id:nonMedicineId.value};
    const paramsSerializer = (params) => qs.stringify(params);
    const response = await axios.get(props.apis.non_medicine_detail,{params:params,paramsSerializer});
    if (response.data.data == null) {
      setDefaultNonMeidicine();
    } else {
      isReadOnly.value = true;
      nonMeidicine.push(response.data.data);
    }
  } finally {
    isLoading.value = false;
  }
}
const UpdateNonMedicineConfirm = async () => {
  let result = await confirmAlert('項目に入力間違いがあると正しく発注などが行えません。十分に確認した上で登録しますか？');
  if (result.isConfirmed) {
    UpdateNonMedicine();
  }
}
const UpdateNonMedicine = async () => {
  let params = {
    id:nonMedicineId.value,
  };
  for (let key in nonMeidicine[0]) {
    params[key] = nonMeidicine[0][key];
  }
  isLoading.value = true;
  try {
    const response = await axios(props.apis.update_non_medicine,{method:"post",data:params});
    if (response.data.status == 200) {
      if (typeof props.submit !== 'undefined') {
        props.submit(response.data.data);
      }
      setDefaultNonMeidicine();
    }
  } finally {
    isLoading.value = false;
  }
}
const cancelNonMedicineEdit = () => {
  if (typeof props.cancel !== 'undefined') {
    props.cancel();
  }
  setDefaultNonMeidicine();
}
const setNonMedicineValue = (value,option) => {
  let data = {};
  if (nonMeidicine.length > 0) {
    data = deepCopy(nonMeidicine[0]);
  }
  data[option.field_key] = value;
  nonMeidicine.splice(0);
  nonMeidicine.push(data);
}
const onChangeNonMedicineValue = (value,option) => {
  setNonMedicineValue(value,option);
}
const onChangeNonMedicineSelectValue = (value,label,option) => {
  let data = {};
  if (nonMeidicine.length > 0) {
    data = deepCopy(nonMeidicine[0]);
  }
  data[option.field_key] = value;
  nonMeidicine.splice(0);
  nonMeidicine.push(data);
}
onMounted(() => {
  setDefaultNonMeidicine();
})
watch(nonMedicineId,(newValue,oldValue) => {
  if (newValue != oldValue) {
    getNonMedicine();
  }
});
watch(identityId,(newValue,oldValue) => {
  getNonMedicine();
});
const getNonMedicineValue = (fieldKey) => {
  let result = '';
  if (nonMeidicine.length > 0) {
    if (typeof nonMeidicine[0][fieldKey] !== 'undefined') {
      result = nonMeidicine[0][fieldKey];
    }
  }
  return result;
}
const nonMedicineValue = computed(() => {
  return (fieldKey) => {
    return getNonMedicineValue(fieldKey);
  };
})
///////// 医療材料選択画面 ///////////
const listMedicalEquipmentRef = ref();
const medicalEquipmentOptionFields = ref({
  'page_size' : 30,
  'is_medical_equipment': 1,
});
const medicalEquipmentFields = ref([
  {field_name: '商品名', field_key: 'product_name', width: '20%', align: 'text-center'},
  {field_name: '商品名(カナ)', field_key: 'half_width_product_name', width: '20%', align: 'text-center'},
  {field_name: '包装単位コード', field_key: 'sales_packaging_unit_code', width: '20%', align: 'text-center'},
  {field_name: '', field_key: 'action', width: '20%', align: 'text-center'}
]);

const isMedicalEquipmentDialog = ref(false);
const showMedicalEquipmentDialog = () => {
  isMedicalEquipmentDialog.value = true;
}
const closeMedicalEquipmentDialog = () => {
  isMedicalEquipmentDialog.value = false;
}
const clickMedicalEquipment = (medicalEquipment) => {
  setNonMedicineValue(medicalEquipment.id,{field_key:'medicine_id'});
  setNonMedicineValue(medicalEquipment.product_name,{field_key:'custom_product_name'});
  setNonMedicineValue(medicalEquipment.half_width_product_name,{field_key:'custom_half_width_product_name'});
  setNonMedicineValue(medicalEquipment.receipt_code1,{field_key:'receipt_code1'});
  setNonMedicineValue(medicalEquipment.package_unit_number,{field_key:'package_unit_number'});
  setNonMedicineValue(medicalEquipment.package_unit,{field_key:'package_unit'});
  setNonMedicineValue(medicalEquipment.package_quantity_number,{field_key:'package_quantity_number'});
  setNonMedicineValue(medicalEquipment.package_quantity,{field_key:'package_quantity_number'});
  closeMedicalEquipmentDialog();
}
////////////////////////////

</script>

<style scoped>
</style>
<template>
<div>
  <div v-show="isLoading" class="loading-mask">
    <div class="loading-content">
      <span style="color: white"><img src="../../../public/images/loading.gif"></span>
    </div>
  </div>
  <table class="w-full">
    <tr v-show="isReadOnly == false" class="border-b border-white">
      <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">商品タイプ</th>
      <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
        <select-box
          :value="nonMedicineValue('medicine_type')"
          :value-options="{field_key:'medicine_type'}"
          :options="config.NON_MEDICINE_TYPES_OPTIONS"
          :on-change="onChangeNonMedicineSelectValue"
        ></select-box>
      </td>
    </tr>
    <tr v-if="isReadOnly == false && nonMedicineValue('medicine_type') != '' && nonMedicineValue('medicine_type') == config.NON_MEDICINE_TYPES['医療材料・医療機器']" class="border-b border-white">
      <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">医療材料</th>
      <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
        <button type="button" @click="showMedicalEquipmentDialog" class="w-full py-2.5 px-5 mr-2 my-2 text-xs font-bold text-white bg-amber-500 rounded-full border-2 border-white dark:border-gray-900">医療材料選択</button>
      </td>
    </tr>
    <tr v-else-if="isReadOnly == false" class="border-b border-white">
      <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">販売包装単位コード<br><br><span v-if="nonMedicineValue('medicine_type') != '' && nonMedicineValue('medicine_type') == config.NON_MEDICINE_TYPES['医療材料・医療機器']">※包装箱のバーコードの(01)で始まる14桁の数字</span><span v-else>※箱のバーコードの4で始まる13桁または8桁の数字</span></th>
      <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
        <text-box
          type="text"
          font-width="half"
          :value="nonMedicineValue('sales_packaging_unit_code')"
          :value-options="{field_key:'sales_packaging_unit_code'}"
          :is-read-only="(isReadOnly && nonMedicineValue('id') > 0) || nonMedicineValue('medicine_type') == config.NON_MEDICINE_TYPES['医療材料・医療機器']"
          :on-change="onChangeNonMedicineValue"
          :on-blur="getMedicine"
        ></text-box>
      </td>
    </tr>
    <tr class="border-b border-white">
      <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">商品名</th>
      <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
        <text-box
          type="text"
          :value="nonMedicineValue('custom_product_name')"
          :value-options="{field_key:'custom_product_name'}"
          :on-change="onChangeNonMedicineValue"
        ></text-box>
      </td>
    </tr>
    <tr class="border-b border-white">
      <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">商品名(カナ)</th>
      <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
        <text-box
          type="text"
          font-width="half_kana"
          :value="nonMedicineValue('custom_half_width_product_name')"
          :value-options="{field_key:'custom_half_width_product_name'}"
          :on-change="onChangeNonMedicineValue"
        ></text-box>
      </td>
    </tr>
    <tr v-show="nonMedicineValue('medicine_type') != '' && nonMedicineValue('medicine_type') == config.NON_MEDICINE_TYPES['医療材料・医療機器']" class="border-b border-white">
      <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">レセ電算コード</th>
      <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
        <text-box
          type="text"
          font-width="half"
          :value="nonMedicineValue('receipt_code1')"
          :value-options="{field_key:'receipt_code1'}"
          :is-read-only="true"
          :on-change="onChangeNonMedicineValue"
        ></text-box>
      </td>
    </tr>
    <tr class="border-b border-white">
      <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">包装単位(数字)<br><span v-if="nonMedicineValue('medicine_type') != '' && nonMedicineValue('medicine_type') == config.NON_MEDICINE_TYPES['医療材料・医療機器']">※アゾセミド錠３０ｍｇ「ＤＳＥＰ」３０ｍｇ／錠　ＰＴＰ　１０錠×１００なら10</span><span v-else>例:OS1 1ロットの中に24本入りなら24</span></th>
      <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
        <text-box
          type="number"
          :value="nonMedicineValue('package_unit_number')"
          :value-options="{field_key:'package_unit_number'}"
          :is-read-only="(isReadOnly && nonMedicineValue('id') > 0) || nonMedicineValue('medicine_type') == config.NON_MEDICINE_TYPES['医療材料・医療機器']"
          :on-change="onChangeNonMedicineValue"
        ></text-box>
      </td>
    </tr>
    <tr class="border-b border-white">
      <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">包装単位(単位)</th>
      <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
        <text-box
          type="text"
          :value="nonMedicineValue('package_unit')"
          :value-options="{field_key:'package_unit'}"
          :is-read-only="(isReadOnly && nonMedicineValue('id') > 0) || nonMedicineValue('medicine_type') == config.NON_MEDICINE_TYPES['医療材料・医療機器']"
          :on-change="onChangeNonMedicineValue"
          place-holder="例：本、錠"
        ></text-box>
      </td>
    </tr>
    <tr v-show="nonMedicineValue('medicine_type') != '' && nonMedicineValue('medicine_type') == config.NON_MEDICINE_TYPES['医療材料・医療機器']" class="border-b border-white">
      <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">包装数量(数字)<br>例:アゾセミド錠３０ｍｇ「ＤＳＥＰ」３０ｍｇ／錠　ＰＴＰ　１０錠×１００なら100</th>
      <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
        <text-box
          type="number"
          :value="nonMedicineValue('package_quantity_number')"
          :value-options="{field_key:'package_quantity_number'}"
          :is-read-only="true"
          :on-change="onChangeNonMedicineValue"
        ></text-box>
      </td>
    </tr>
    <tr v-show="nonMedicineValue('medicine_type') != '' && nonMedicineValue('medicine_type') == config.NON_MEDICINE_TYPES['医療材料・医療機器']" class="border-b border-white">
      <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">包装数量(単位)</th>
      <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
        <text-box
          type="text"
          :value="nonMedicineValue('package_quantity')"
          :value-options="{field_key:'package_quantity'}"
          :is-read-only="true"
          :on-change="onChangeNonMedicineValue"
          place-holder="例：シート、キット、瓶"
        ></text-box>
      </td>
    </tr>
  </table>
  <div class="flex">
    <div class="flex-row mr-2">
      <button type="button" @click="UpdateNonMedicineConfirm" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">登録する</button>
    </div>
    <div class="flex-row">
      <button type="button" @click="cancelNonMedicineEdit" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">キャンセル</button>
    </div>
  </div>
</div>
<modal-dialog
  :is-visible="isMedicalEquipmentDialog"
  help-key="medical_equipment_help"
  width="60%"
  :close="closeMedicalEquipmentDialog"
>
  <template v-slot:header>
    医療材料選択
  </template>
  <template v-slot:default>
  <div>
  <div class="w-full">
      <custom-list
        ref="listMedicalEquipmentRef"
        :table-fields="medicalEquipmentFields"
        :api-url="apis.medicine_list"
        :option-fields="medicalEquipmentOptionFields"
        height="72vh"
      >
      <template v-slot:item="slotProps">
        <td v-for="(field,index) in medicalEquipmentFields" :style="'width:' + field.width" :class="field.align">
          <div v-if="field.field_key != 'action'" :class="field.align">
            {{ getFieldValue(slotProps.item,field.field_key) }}
          </div>
          <div v-else :class="field.align">
            <a href="javascript:void(0)" @click="clickMedicalEquipment(slotProps.item)"><i class="fa-regular fa-pen-to-square text-lg"></i></a>
          </div>
        </td>
      </template>
      </custom-list>
      <div></div>
  </div>
  </div>
  </template>
</modal-dialog>

</template>

